<template>
    <v-card flat class="d-flex align-center justify-center">
        <v-img src="@/assets/comingSoon.svg" contain width="700" height="700"></v-img>
    </v-card>
</template>
<script>
export default {
    name: "checkIn"
}
</script>